"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["question", "unique", "test", "value"],

  mixins: [require("../../mixins/HasReferences.js")],

  computed: {
    isEmptyRange: function isEmptyRange() {
      return Object.values(this.minMax).every(function (o) {
        return o === null;
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/printtest/Question.vue
// module id = 0gqb
// module chunks = 0 1